import { addDays, format } from 'date-fns';

// 더미 데이터 생성 공용 도구 — 실행할 때마다 같은 결과가 나오도록 시드 고정 난수를 쓴다.
// 날짜는 "오늘" 기준 상대값이라 언제 열어도 시작·종료 일정이 가까운 미래에 생긴다.

/** mulberry32 — 시드 고정 난수 생성기 */
export function createRandom(seed: number) {
  let state = seed;
  const next = () => {
    state |= 0;
    state = (state + 0x6d2b79f5) | 0;
    let t = Math.imul(state ^ (state >>> 15), 1 | state);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  return {
    next,
    int: (min: number, max: number) => Math.floor(next() * (max - min + 1)) + min,
    pick: <T>(items: readonly T[]): T => {
      const item = items[Math.floor(next() * items.length)];
      if (item === undefined) {
        throw new Error('pick: empty list');
      }
      return item;
    },
    chance: (probability: number) => next() < probability,
  };
}

export const TODAY = new Date();
TODAY.setHours(0, 0, 0, 0);

/** 오늘 기준 offset일 뒤의 yyyy-MM-dd */
export const dayFromToday = (offset: number) => format(addDays(TODAY, offset), 'yyyy-MM-dd');
